export default "__VITE_ASSET__03b87e9b__"